module.exports = __webpack_public_path__ + "assets/media/day25.c977f852.mp3";